import { t } from 'i18next';
import type { ErrorStrategy } from '../types';

export const typeStrategy: ErrorStrategy = ({ instancePath, params }) => {
  // implies a $data reference or otherwise set allowedValue in the Schema
  const { type } = params;

  // Use QuantityValueType translation for integer to be consistent
  const translatedType = type === 'integer' ? t('QuantityValueType.IntegerNumber') : type;

  return {
    path: instancePath,
    message: t('ErrorStrategyType', { type: translatedType }),
  };
};
